
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/template-select.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-template-select-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/template-select.md?type=demo')
};